import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentClassList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentClass', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    const classTypeColumn = (rowData) => {
        const typeMap = {
            0: t('Normal'),
            1: t('Special'),
            2: t('Other')
        }
        return typeMap[rowData.Type] || rowData.Type || ''
    }

    return (
        <M_Table
            entityName={'EquipmentClass'}
            api='secondary'
            showTitle={true}
            title={'Equipment Classes'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentClassCrud', 'Create', t('Add')+' '+t('Equipment')+' '+ t('Class'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentClassCrud', 'Edit', t('Edit')+' '+t('Equipment')+' '+ t('Class'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentClassCrud', 'Copy', t('Copy')+' '+t('Equipment')+' '+ t('Class'), row)]
            ])}
            columnTemplates={[
                {
                    field: 'Type',
                    body: classTypeColumn
                }
            ]}
        />
    )
}